import { render, staticRenderFns } from "./NoticePop.vue?vue&type=template&id=53cbf0aa&"
import script from "./NoticePop.vue?vue&type=script&lang=js&"
export * from "./NoticePop.vue?vue&type=script&lang=js&"
import style0 from "./NoticePop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports